<form
  class="cooperation-form"
  [formGroup]="formGroup()"
>
  @if (currentStep() === 2) {
    <p>Предложение о сотрудничестве успешно создано!</p>
    <mat-form-field
      appearance="outline"
      class="none-pointer-events"
    >
      <mat-label>Идентификатор</mat-label>
      <input
        matInput
        [formControlName]="'id'"
      >
    </mat-form-field>
  }

  @for (field of addCooperationOfferFormFields; track $index) {
    @if (!field.hidden) {
      <mat-form-field
        appearance="outline"
        [class.none-pointer-events]="currentStep() === 2"
      >
        <mat-label>{{ field.label }}</mat-label>
        <input
          matInput
          [formControlName]="field.fieldName"
          (input)="onInputChange($event, field.fieldName)"
        >
      </mat-form-field>
    }
  }
</form>
<div class="cooperation-buttons">
  <button
    mat-button
    type="button"
    [color]="currentStep() === 2 ? 'primary' : 'warn'"
    (click)="handleClose.emit('cancel')"
  >
    {{ getNameButtonClose(currentStep()) }}
  </button>
  @if (currentStep() === 0) {
    <button
      mat-button
      matStepperNext
      color="primary"
      type="button"
      [disabled]="formGroup().invalid"
      (click)="nextStepClick()"
    >
      Продолжить
    </button>
  }
</div>
